module.exports = __webpack_public_path__ + "static/banner-bg-2847e103c898fdbbf2b627cab3167012.svg";